import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
import ImgBox from "./panel-imgbox";
import { goToPay, checkOrderStatus } from "../service";
import Qrcode from 'qrcodejs2';
export default {
  components: {
    panel: panel,
    ImgBox: ImgBox
  },
  props: {
    price: {
      type: Number,
      default: 0
    },
    originPrice: {
      type: Number,
      default: 0
    },
    // 根据版本号进行充值
    version: {
      type: String,
      default: 'standard'
    },
    isUpdate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    discount: function discount() {
      return this.originPrice - this.price;
    },
    typeName: function typeName() {
      if (this.version === 'standard') {
        return '标准版会员';
      } else if (this.version === 'speciality') {
        return '专业版会员';
      } else if (this.version === 'enjoy') {
        return '尊享版会员';
      } else {
        return '定制平台';
      }
    }
  },
  data: function data() {
    return {
      orderId: null,
      // 订单编号，监听到订单编号识别是否支付成功
      difPrice: 0 // 计算好差价之后得价格

    };
  },
  watch: {
    orderId: function orderId(e) {
      this.renderOrder(e);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var el, loading, respone, padding, paddingInt, offsetWidth, offsetHeight, qrcode;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              el = this.$refs.qrcodeBox.$el;
              loading = _Loading.service({
                target: el,
                background: 'rgba(0,0,0,0.5)'
              });
              _context.next = 4;
              return goToPay(this.version);

            case 4:
              respone = _context.sent;
              loading.close();

              if (el) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              padding = this.getComputedStyle(el, 'paddingLeft');
              paddingInt = +padding.replace('px', '');
              offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;

              if (respone) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return");

            case 13:
              this.orderId = respone.outTradeNo; // 记录订单号

              this.difPrice = (respone.difPrice / 100).toFixed(2);
              qrcode = new Qrcode(el, {
                text: respone.codeUrl,
                width: offsetWidth - 2 * paddingInt,
                height: offsetHeight - 2 * paddingInt,
                colorDark: '#000000',
                colorLight: '#ffffff'
              });
              this.$once('hook:beforeDestroy', function () {
                qrcode.clear();
                loading.close();
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    this.clearInterval();
  },
  methods: {
    // 清除定时器
    clearInterval: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      if (this.oidTimer) {
        clearInterval(this.oidTimer);
      }
    }),
    // 获取计算样式信息
    getComputedStyle: function getComputedStyle(obj, attr) {
      if (obj.currentStyle) {
        return obj.currentStyle[attr];
      } else {
        return document.defaultView.getComputedStyle(obj, null)[attr];
      }
    },
    // 轮询订单
    renderOrder: function renderOrder(oid) {
      var _this = this;

      this.clearInterval();
      this.oidTimer = setInterval(function () {
        checkOrderStatus(oid, _this.version).then(function (r) {
          if (r) _this.paySuccess(r); // this.paySuccess('2021-09-22')
        });
      }, 5000);
    },
    // 订单支付成功回调,传出有效期
    paySuccess: function paySuccess(validTime) {
      this.$emit('success', {
        validTime: validTime
      });
    }
  }
};